// Centralized data-testid constants for the Knight Notary marketing site.
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  root: "nav-root",
  logo: "nav-logo",
  linkServices: "nav-link-services",
  linkAbout: "nav-link-about",
  linkContact: "nav-link-contact",
  ctaCall: "nav-cta-call",
};

export const HERO = {
  root: "hero-root",
  eyebrow: "hero-eyebrow",
  title: "hero-title",
  subtitle: "hero-subtitle",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
  logoImg: "hero-logo-img",
};

export const SERVICES = {
  root: "services-root",
  card: (slug) => `service-card-${slug}`,
};

export const ABOUT = {
  root: "about-root",
  cta: "about-cta",
};

export const TESTIMONIALS = {
  root: "testimonials-root",
  card: (i) => `testimonial-card-${i}`,
};

export const WHY = {
  root: "why-root",
  pill: (i) => `why-pill-${i}`,
};

export const HOW = {
  root: "how-root",
  step: (i) => `how-step-${i}`,
};

export const AREAS = {
  root: "areas-root",
  card: (slug) => `area-card-${slug}`,
};

export const FAQ = {
  root: "faq-root",
  item: (i) => `faq-item-${i}`,
};

export const CONTACT = {
  root: "contact-root",
  form: "contact-form",
  inputName: "contact-input-name",
  inputEmail: "contact-input-email",
  inputPhone: "contact-input-phone",
  inputService: "contact-input-service",
  inputMessage: "contact-input-message",
  submit: "contact-submit",
  success: "contact-success",
  error: "contact-error",
  phoneLink: "contact-phone-link",
  emailLink: "contact-email-link",
  websiteLink: "contact-website-link",
};

export const FOOTER = {
  root: "footer-root",
};
